import isObject from 'lodash/isObject';
import { isCopyToClipboardSupported, copyToClipboard } from '@/utils/vuex';
export default {
  name: 'CustomCopyClipboard',
  props: {
    content: {
      type: null,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isTruncated: false
    };
  },
  computed: {
    internalContent() {
      if (this.content === null || this.content === undefined) {
        return String(this.content);
      }
      const stringified = JSON.stringify(this.content, null, 2);
      return isObject(this.content) && stringified ? stringified : this.content;
    },
    isCopySupported() {
      return isCopyToClipboardSupported();
    }
  },
  mounted() {
    this.isTruncated = this.$refs.text.offsetWidth < this.$refs.text.scrollWidth;
  },
  methods: {
    copyToClipboard(event, copyValue) {
      event.stopPropagation();
      copyToClipboard(copyValue);
    }
  }
};